import jwt from "jwt-decode";
import Cookies from "universal-cookie";

const cookies = new Cookies();

/* export function setToken(token: any) {
  if (token) {
    cookies.set("hdb-token", token, { path: "/" });
    const user = jwt(token);
    localStorage.setItem("hdbUserInfo", JSON.stringify(user));
  } else {
    cookies.remove("hdb-token");
  }
} */

/* export function getToken() {
  const token = cookies.get("hdb-token");
} */

export function getTokenDcrypted(token: any) {
  if (!token) return;
  return jwt(token);
}

export function getUserInfo() {
  const user = JSON.parse(
    JSON.parse(JSON.stringify(localStorage.getItem("hdbUserInfo")))
  );
  return user;
}

function clearAllCookies() {
  const allCookies = cookies.getAll();

  for (const cookieName in allCookies) {
    cookies.remove(cookieName);
  }
}

export function signOut() {
  clearAllCookies();
  const provider = localStorage.getItem("customAuthType") || "AD";
  localStorage.clear();
  sessionStorage.removeItem("currentUrl");
  localStorage.setItem("customAuthType", provider);
}

export function isLoggedIn() {
  try {
    const userInfoString = localStorage.getItem("hdbUserInfo");
    if (!userInfoString) return false;

    const isLogout = localStorage.getItem("isLogout");
    if (isLogout === "true") {
      return false;
    }

    const user = JSON.parse(userInfoString);
    return !!user && typeof user === "object" && Object.keys(user).length > 0;
  } catch (error) {
    console.error("Auth check error:", error);
    return false; // Fail securely
  }
}
